import styled, { css } from 'styled-components/macro';

export const IconWrapper = styled.div<{
  inputSuffix?: boolean;
  stroke?: string;
  position?: string;
}>`
  ${({ inputSuffix, position }) =>
    inputSuffix &&
    css`
      position: ${position ? position : 'absolute'};
      ${position && 'z-index: 1'};
      top: 2.3rem;
      right: 1rem;

      margin: auto;

      cursor: pointer;
    `};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    top: 1.8rem;
  }
`;
